import type { AppMode } from "./types";

export interface StoredConfig {
  mode?: AppMode;
  localBaseUrl?: string;
  localTenantId?: string;
  [key: string]: unknown;
}

export const STORAGE_KEY = "harmony-management-config";

export const getStoredConfig = (): StoredConfig | null => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored) as StoredConfig;
    }
  } catch (error) {
    console.error("Failed to load config from localStorage:", error);
  }
  return null;
};
